import { Component, effect, inject, signal } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { CommonModule } from '@angular/common';

import { VbLxpPanelComponent } from '../../panel/vb-lxp-panel.component';
import { TimingTowerFullComponent } from '../../timing-tower/timing-tower-full.component';
import { RaceSessionService } from '../../timing-tower/race-session.service';
import { TimingTowerService } from '../../timing-tower/timing-tower.service';
import { VbLxpMapComponent } from '../../map/map.component';
import { TimespanPipe } from '../../shared/time-span.pipe';
import { RaceInfoService } from '../../shared/race-info.service';
import { FavoriteDriverService } from '../../shared/favorite-driver.service';
import { VisibilitiesService } from '../../shared/visibilities.service';
import { FeatureSettingsService } from '../../shared/feature-settings.service';

@Component({
	selector: 'vb-lxp-full-timing-page',
	imports: [
		CommonModule,
		VbLxpPanelComponent,
		TimingTowerFullComponent,
		VbLxpMapComponent,
		TimespanPipe,
	],
	templateUrl: './vb-lxp-full-timing-page.component.html',
	styleUrl: './vb-lxp-full-timing-page.component.css',
})
export class VbLxpFullTimingPageComponent {
	public timingTowerService = inject(TimingTowerService);
	public raceSessionService = inject(RaceSessionService);
	public raceInfoService = inject(RaceInfoService);
	public favoriteDriverService = inject(FavoriteDriverService);
	public featureSettingsService = inject(FeatureSettingsService);
	public selectedClasses = toSignal(this.raceSessionService.selectedClasses$, { initialValue: [] });
	public readonly visibilitiesService = inject(VisibilitiesService);

	// Delegate to RaceInfoService
	public raceStatus = this.raceInfoService.raceStatus;
	public timeStatus = this.raceInfoService.timeStatus;
	public trackTempDisplay = this.raceInfoService.trackTempDisplay;
	public windSpeedDisplay = this.raceInfoService.windSpeedDisplay;
	public windDirectionDegrees = this.raceInfoService.windDirectionDegrees;
	public windDirectionLabel = this.raceInfoService.windDirectionLabel;
	public localTimeDisplay = this.raceInfoService.localTimeDisplay;
	public trackTitle = signal('');

	public trackTitleMap = {
		'barber_track.geojson': 'Barber Motorsports Park',
		'cota_track.geojson': 'Circuit of the Americas',
		'mid_ohio_track.geojson': 'Mid-Ohio Sports Car Course',
		'road_america.geojson': 'Road America',
		'road_atlanta.geojson': 'Road Atlanta',
		'sebring_track.geojson': 'Sebring International Raceway',
	};

	constructor() {
		const driversRef = effect(() => {
			if (this.raceSessionService.raceTeamsPosition().length !== 0) {
				this.setFavoriteDrivers();
				driversRef.destroy();
			}
		});
		this.featureSettingsService.featureSettings$.subscribe((settings) => {
			if (settings.track) {
				this.trackTitle.set(settings.track.title);
			}
		});
	}

	setFavoriteDrivers() {
		const favoriteDrivers = this.raceSessionService
			.raceTeamsPosition()
			.filter((t) => this.favoriteDriverService.isFavoriteDriver(t));
		favoriteDrivers.map((fd) => fd.number).forEach((n) => this.timingTowerService.setActive(n));
	}

	public openFullMapPage() {
		const currentParams = new URLSearchParams(window.location.search).toString();
		const base = new URL('map-popout', document.baseURI).toString();
		const url = currentParams ? `${base}?${currentParams}` : base;
		const width = 1280;
		const height = 720;
		window.open(url, '_blank', `width=${width},height=${height},resizable=yes`);
	}
}
